import React, { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Field,
  IconClose,
  InputSelect,
  LabeledField
} from '@Knowledge-OTP/znk-ui-components'
import styles from './styles.module.css'
import { useDispatch } from 'react-redux'
import { SET_DATA_MODAL_FORM_LIST } from '../../../../../store/modal/const'
import ToggleReminder from './ToggleReminder'
import omit from 'lodash/omit'
import ToggleTimedReminder from './ChangeReminder'
import escapeRegExp from 'lodash/escapeRegExp'
import useModalState from '../../../../../utils/useModalState'
import ChangeNotificationsInner from './innerModal/index'
import { gql, useMutation } from '@apollo/client'
import useTranslation from '../../../../../i18n/useTranslation'

const ChangeNotificationsModal = (props) => {
  const {
    toggleFull,
    user,
    onUserUpdated,
    isParent = false,
  } = props
  const { translate } = useTranslation()

  const defaultParentDigest = user?.parentInfo?.notifications?.digest ?? 'never'
  const digestOptions = [
    { id: 'never', label: 'Never' },
    { id: 'daily', label: 'Daily' },
    { id: 'weekly', label: 'Weekly' }
  ]
  const { modalData, onChange } = useModalState('user.notificationHub')
  const { studentInfo, id } = modalData
  const userId = user?.id || id
  const refetch = (studentInfo) => onChange((f) => ({ ...f, studentInfo }))
  const [parentReminder, setParentReminder] = useState({
    digest: defaultParentDigest
  })
  const [hasEditedDigest, setHasEditedDigest] = useState(false)
  useEffect(() => {
    if (!hasEditedDigest) {
      setParentReminder({ digest: defaultParentDigest })
    }
  }, [defaultParentDigest, hasEditedDigest])
  const notificationsSettings = useMemo(() => {
    return studentInfo && studentInfo.notifications
      ? omit(studentInfo.notifications, [
        '__typename',
        'lessonReminder.__typename'
      ])
      : {
        missedLesson: true,
        lessonsNotesReady: true,
        lessonReminder: { isAvailable: true, duration: 30 }
      }
  }, [studentInfo])
  // const { breakWidth } = useWindowDimensions()
  const dispatch = useDispatch()
  const [updateUser, { loading: isSavingParentDigest }] = useMutation(
    gql`
      mutation($input: UpdateUserInput!, $id: ID) {
        updateUser(input: $input, id: $id) {
          id
        }
      }
    `
  )
  const editReminder = (reminderType, reminderKey, reminderValue) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'user.notificationToggle',
      data: {
        isOpen: true,
        reminderType,
        reminderValue,
        reminderKey,
        prevNotifs: notificationsSettings
      }
    })
  }
  const editTimedReminder = (reminderType, reminderKey, reminderValue) => {
    dispatch({
      type: SET_DATA_MODAL_FORM_LIST,
      payload: 'user.notificationChange',
      data: {
        isOpen: true,
        reminderType,
        reminderValue,
        reminderKey,
        prevNotifs: notificationsSettings
      }
    })
  }
  const onSaveDigest = () => {
    if (!hasEditedDigest || !parentReminder?.digest || !userId) return
    updateUser({
      variables: {
        id: userId,
        input: {
          parentInfo: {
            notifications: {
              digest: parentReminder.digest
            }
          }
        }
      }
    })
      .then(() => {
        setHasEditedDigest(false)
        if (onUserUpdated) onUserUpdated()
      })
      .catch(() => null)
  }
  return (
    <>
      {!isParent && (
        <>
          <ChangeNotificationsInner
            notificationsSettings={notificationsSettings}
            editReminder={editReminder}
            editTimedReminder={editTimedReminder}
            styles={styles}
            toggle={toggleFull}
          />
          <ToggleReminder refetch={refetch} userId={userId} />
          <ToggleTimedReminder refetch={refetch} userId={userId} />
        </>
      )}
      {isParent && (
        <div className='w-100 py-5 px-8'>
          <span className='d-flex w-100 flex-row justify-content-between'>
            <h2 className='font-weight-bold'>Notifications</h2>
            <IconClose onClick={toggleFull} className='text-cancel' />
          </span>
          <div className='container-fluid flex-column my-2 px-0'>
            <p className={`h3 font-weight-normal mb-1 ${styles.lineH24}`}>
              {translate('profile.actions.changeNotifications.reminder')}
            </p>
            <Field
              className='col-12 m-0 p-0'
              type={LabeledField}
              component={InputSelect}
              onChange={(name) => {
                setHasEditedDigest(true)
                setParentReminder({ digest: name })
              }}
              fieldName='digest'
              value={parentReminder?.digest}
              options={digestOptions.map((opt) => ({
                value: opt.id,
                label: opt.label
              }))}
              PlaceholderSelect={translate(
                'profile.actions.changeNotifications.reminder'
              )}
              filterOption={(obj, string) => {
                if (new RegExp(escapeRegExp(string), 'i').test(obj.label)) {
                  return true
                }
                return false
              }}
              isClearable={false}
            />
            <Button
              className='mt-3'
              label={translate('misc.saveChanges')}
              color='primary'
              size='medium'
              onClick={onSaveDigest}
              disabled={!hasEditedDigest || isSavingParentDigest}
              activity={isSavingParentDigest}
              style={{ width: '100%' }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ChangeNotificationsModal
